module.exports = __webpack_public_path__ + "img/illust-oji-close.b8d1817d.png";